import { Component, ChangeDetectorRef, NgZone, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MediaMatcher } from "@angular/cdk/layout";
import { UserService } from "./_services/user.service";
import * as firebase from 'firebase';
import { AngularFireDatabase } from "angularfire2/database-deprecated";
import { BadwordsService } from "./_services/badwords.service";
import { NotificationService, AlertService } from "./_services";
import { Observable, Subscription } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SplashScreenService } from "./_services/splash-screen.service";
import { SaveMessageComponent } from "./directive/save-message/save-message.component";
import { MatDialog } from "@angular/material";
import { PhoneTakeRequestComponent } from "./directive/phone-take-request/phone-take-request.component";
import { ScrollService } from "./_services/scroll.service";
import { MetaService } from "ng2-meta";
import { AngularFirestore } from 'angularfire2/firestore';
import { skipUntil } from 'rxjs/operators';
import { Http } from '@angular/http';
import { HttpParams, HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  apiKey = 'AIzaSyChOi-WqoG0mzySEZ3nt8_7pSDj4H3ojuc';
  url = 'https://translation.googleapis.com/language/translate';
  result: any;
  q = '';

  mobileQuery: any;
  user;
  onlineOffline: Observable<boolean>;
  userId;
  ipAddress: any;
  unseenNotifications: Observable<any[]>;
  unseenNotifications1 = [];
  messagesNotifications = [];
  private subs = new Subscription();
  subsBadge = new Subscription();
  private _mobileQueryListener: () => void;
  constructor(private media: MediaMatcher,
    private router: Router,
    private http: HttpClient,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private afs: AngularFirestore,
    private userService: UserService,
    private badwordService: BadwordsService,
    private splashScreen: SplashScreenService,
    private notificationService: NotificationService,
    private modalService: NgbModal,
    private zone: NgZone,
    private alertService: AlertService,
    private _http: Http,
    private scrollservice: ScrollService,
    private metaService: MetaService) {

    this.splashScreen.hide();
    (<any>window).renderComplete = true;
    this.badwordService.initialize();



    this.getIpAdress();
    this.subs = this.userService.getUser().skipWhile(v => Object.keys(v).length === 0).subscribe(user => {

      this.user = user;
      // this.user['badges'] = user['badges'] ? Object.keys(user['badges']) : [];
      if (user) {
        this.unseenNotifications = this.notificationService.getUnseenNotifications();
        if (this.unseenNotifications) {
          this.subs = this.unseenNotifications.subscribe(data => {
            this.unseenNotifications1 = data.sort(function (a, b) {
              a = a.modifyDate;
              b = b.modifyDate;
              return a < b ? 1 : a > b ? -1 : 0;
            });

          });
        }


        if (user.point) {

          this.messagesNotifications = Object.values(user.messagesNotifications ? user.messagesNotifications : []).filter(data => {
            return data['isUnseen'];
          });
        }
      }
      this.userId = localStorage.getItem('currentUserId');
    });


    try {
      this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
      this._mobileQueryListener = () => this.cd.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
    } catch (e) {
    }
    this.onlineOffline = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').mapTo(true),
      Observable.fromEvent(window, 'offline').mapTo(false)
    )
    this.onlineOffline.subscribe(data => {
      if (!data) {
        let dialog = this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Hmm! İnternet bağlantında sorun olabilir mi?",
            type: "update"
          }
        });
        dialog.afterClosed().subscribe(() => window.location.reload());
      }
    });
  }

  translate(text: string) {
    var url = "https://translate.googleapis.com/translate_a/single?client=gtx&sl=tr&tl=en&dt=t&q=" + encodeURI(text);
    var url2 = "https://westus2.api.cognitive.microsoft.com/text/analytics/v3.0-preview.1/sentiment";
    var url3 = "https://westus2.api.cognitive.microsoft.com/text/analytics/v2.1/keyPhrases";


    this.http.get(url).toPromise().then((result) => {
      console.log(result);
      this.result = result[0][0][0];

      this.http.post(url2, JSON.stringify(
        {
          "documents": [
            {
              "language": "en",
              "id": "1",
              "text": this.result
            }

          ]
        }
      ), {
          headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": "3f2650e45bd2459fbb773e1947ccc469"
          }
        }).toPromise().then(data => {
          console.log(data['documents'][0]);
        })


      this.http.post(url3, JSON.stringify(
        {
          "documents": [
            {
              "language": "en",
              "id": "1",
              "text": this.result
            }

          ]
        }
      ), {
          headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": "3f2650e45bd2459fbb773e1947ccc469"
          }
        }).toPromise().then(data => {
          console.log(data);
        })
    })




    // $(function () {
    //   $.ajax({
    //     url: "https://westus2.api.cognitive.microsoft.com/text/analytics/v2.1/sentiment",
    //     beforeSend: function (xhrObj) {
    //       // Request headers
    //       xhrObj.setRequestHeader("Content-Type", "application/json");
    //       xhrObj.setRequestHeader("Ocp-Apim-Subscription-Key", "3f2650e45bd2459fbb773e1947ccc469");
    //     },
    //     type: "POST",
    //     // Request body

    //     data: JSON.stringify({
    //       "documents": [
    //         {
    //           "language": "en",
    //           "id": "1",
    //           "text": "Hello world. This is some input text that I love."
    //         }

    //       ]
    //     }
    //     )
    //   })
    //     .done(function (data) {
    //       console.log(data);
    //       alert("success");
    //     })
    //     .fail(function () {
    //       console.log('fail')
    //       alert("error");
    //     });
    // });



  }
  ngOnInit() {
    if (this.user) {

      this.subsBadge.add(this.afs.collection('users').doc(localStorage.getItem('currentUserId')).valueChanges().subscribe(data => {

        setTimeout(() => {



          if (data['point'].totalPoint === 250 || data['point'].totalPoint === 750 || data['point'].totalPoint === 1500) {

            this.setPopUp(data)



          }
        }, 1000);
      }));
    }

  }


  setPopUp(user) {


    this.afs.collection('levels').ref.get().then((data => {
      let levels = [];
      data.forEach(a => {
        levels.push(a.data());

      })
      const upperLevel = levels.filter(item => {
        return user.level + 1 === item.level;
      })[0];
      if (upperLevel && !user[upperLevel.description]) {
        const upperLevelPoint = upperLevel.point;
        if (user.point.totalPoint >= upperLevelPoint) {
          user.level = user.level + 1;


          const dia = this.dialog.open(SaveMessageComponent, {
            width: '400px',
            data: {
              message: "Bir üst seviyeye atlayarak '" + upperLevel.description + "' oldun.",
              type: "post",
              level: upperLevel.description
            }
          });
          dia.afterClosed().subscribe(() => {
            this.subsBadge.unsubscribe();
          })


          this.afs.collection('users').doc(localStorage.getItem('currentUserId')).update({
            [upperLevel.description]: true,
            level: user.level
          })
        }
      }

    }));

  }
  xx() {
    this.scrollservice.isScroll.next(true);
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
    if (this.subsBadge) {
      this.subsBadge.unsubscribe();
    }

    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  toogleNav(nav: any) {
    if (nav.opened) {
      nav.close()
    } else {
      nav.open();
    }
  }

  getIpAdress() {
    this.subs.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }

  logout() {
    this.afs.collection('logs').add({
      userId: this.user.id,
      date: new Date(),
      type: 'logout',
      ipAddress: this.ipAddress,
      url: 'bigadvice.com'
    }).then(() => {

      firebase.auth().signOut().then(() => { this.userService.clearUser(); localStorage.clear() }).then(() => this.router.navigate(["/"]));
    });

  }
  open(content) {

    if (this.userId) {
      this.afs.collection('posts').ref.where('user', '==', this.userId).get().then(data => {
        const x = [];
        data.forEach(post => {
          if (post.data().modifyDate > Date.now() - 86400000) {
            x.push(post.data());
          }
        });
        if (x.length >= 10) {
          this.dialog.open(SaveMessageComponent, {
            width: '600px',
            data: {
              message: 'Günlük paylaşım hakkını doldurdun, ama biz seni dinlemeye doyamadık! Yarın yeni paylaşımların için bekliyoruz :)',
              type: "update"
            }
          });

        }
        else {

          this.modalService.open(content, { backdrop: "static" });
        }
      })

    } else {
      this.router.navigate(["/auth"]);
    }
  }
  requestPhone() {
    if (this.userId) {
      this.dialog.open(PhoneTakeRequestComponent, {
        width: 'auto',
        height: '80%',
        data: {
          title: 'Tebrikler!',
          type: "badge",
          image: "categoryIcons/" + "category.uniqueName" + ".png",
          content: "category.name" + ' kategorisinde uzmanlık kazandın.'
        }
      });
    }
    else {
      this.router.navigate(['/auth']);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/app.component.ts